import {Component, Inject, Vue} from "vue-property-decorator";
import Utils from "@/vue/infrastructure/utils/helpers";
import VueBarcode from "vue-barcode";
import { IMaskDirective } from "vue-imask";
import DfStore from "@/vue/domain/store/df-store";
import DfUser from "@/vue/domain/user/df-user";
import DfBrand from "@/vue/domain/brand/df-brand";
import DfProperty from "@/vue/domain/content/df-property";
import Swal from "sweetalert2";
import {CONTAINER_TYPES} from "@/vue/infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";

const DfHeaderMobileComponent = () =>
  Utils.externalComponent2("df-header-mobile");
const DfStoreCardComponent = () => Utils.externalComponent2("df-store-card");

@Component({
  components: {
    DfHeaderMobile: DfHeaderMobileComponent,
    DfStoreCard: DfStoreCardComponent,
    VueBarcode,
  },
  directives: {
    imask: IMaskDirective,
  },
})
export default class DfPageAccountCardComponent extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;

  private clubCardNumberError = false;

  get brand(): DfBrand {
    return this.$store.getters.brand;
  }

  get clubCardNumber(): DfUser {
    return Utils.getPropertyValue(
      this.currentUser,
      Utils.PROPERTY_USER_CAMI_CARD_NUMBER,
      "STRING"
    );
  }

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get currentUser(): DfUser {
    return this.$store.getters.user;
  }

  get fullName(): string {
    const firstName: string = Utils.getPropertyValue(
      this.currentUser,
      "FIRST_NAME",
      "STRING",
      ""
    );
    const lastName: string = Utils.getPropertyValue(
      this.currentUser,
      "LAST_NAME",
      "STRING",
      ""
    );
    const fullName = [firstName, lastName].join(" ");
    return fullName.trim().length > 0 ? fullName : null;
  }

  get clubCardBackgroundImage(): any {
    return Utils.getPropertyImageUrl(
      this.brand,
      Utils.PROPERTY_CARD_CLUB_MY_AREA_BACKGROUND_IMAGE,
      "string"
    );
  }

  get extraText(): boolean {
    return this.brand.alias === "dpiu-maxidi";
  }

  get registrationMode(): string {
    const propertyValue: any = Utils.getPropertyValue(this.brand, Utils.PROPERTY_REGISTRATION_MODE, "LIST");
    return propertyValue ? propertyValue.key : Utils.REGISTRATION_MODE_STANDARD;
  }

  get showAdvancedActions(): boolean {
    return this.registrationMode !== Utils.REGISTRATION_MODE_STANDARD && !!this.currentUser;
  }

  beforeMount() {
    this.$root.$emit("loadUser");
  }

  private bindCamiCard() {
    this.$router.push({ name: "user-registration", params: { storeAlias: this.currentStore.alias } });
  }

  private goToStorePage(store: DfStore) {
    this.$router
      .push({ name: "store", params: { storeAlias: store.alias } })
      .catch((err) => err);
  }

  private openMap() {
    window.open(
      `${Utils.GOOGLE_MAP_URL}${Utils.storeGoogleMapsCoordinates(
        this.currentStore
      )}`,
      "_blank"
    );
  }

  private unbindCamiCard() {
    Swal.fire({
      title: this.$t("df-page-user-registration.modal.request-unbind-cami-card.save.title").toString(),
      text: this.$t("df-page-user-registration.modal.request-unbind-cami-card.save.body").toString(),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.$t("df-page-user-registration.modal.request-unbind-cami-card.save.ok").toString(),
    }).then((result) => {
      if (result.value) {
        this.service
          .unbindCamiCard()
          .then((response: any) => {
            Swal.fire({
              title: this.$t("df-page-user-registration.modal.unbind-cami-card.save.title").toString(),
              text: this.$t("df-page-user-registration.modal.unbind-cami-card.save.body").toString(),
              icon: "info",
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("df-page-user-registration.modal.unbind-cami-card.save.ok").toString(),
            }).then((result) => {
              this.$router.push({ name: "account-card" });
            });
          })
          .catch((error: Error) => {
            Utils.defaultApiErrorHandler(error, this, () => { this.unbindCamiCard() });
          });
      }
    });
  }
}
